import chooseImage from "./chooseImage";
import compressImage from "./compressImage";
import getImageInfo from "./getImageInfo";
import previewImage from "./previewImage";
import saveImage from "./saveImage";
export { chooseImage, compressImage, getImageInfo, previewImage, saveImage };
export default {
  chooseImage: chooseImage,
  compressImage: compressImage,
  getImageInfo: getImageInfo,
  previewImage: previewImage,
  saveImage: saveImage
};